export default "__VITE_ASSET__tttzhVsc__"